import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import paywallsActions from 'redux/actions/paywallsActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import UnauthorizedCreateModal from 'views/paywalls/modals/google_slides_unauthorized_create_modal'

class GoogleSlidesUnauthorizedCreateContainer extends PureComponent {
	trialCode = 'NP-GOLDGS'

	handleUpgradeSelected = () => {
		this.props.actions.upgradeSelected(this.trialCode)
	}

	render() {
		return (
			<UnauthorizedCreateModal
				handleUpgrade={this.handleUpgradeSelected}
				handleCloseConfirm={this.props.actions.closeConfirmSelected}
				upgradeCode={this.trialCode}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		upgradeSelected: paywallsActions.googleSlidesCreateAsUnauthorized,
		closeConfirmSelected: paywallsActions.googleSlidesUnauthorizedCreateClose,
	}, dispatch)
}

GoogleSlidesUnauthorizedCreateContainer.propTypes = {
	actions: PropTypes.shape({
		upgradeSelected: PropTypes.func.isRequired,
		closeConfirmSelected: PropTypes.func.isRequired,
	}),
}

export default connect(null, mapDispatchToProps)(
	GoogleSlidesUnauthorizedCreateContainer
)

export { GoogleSlidesUnauthorizedCreateContainer }
